import { NotificationStatus } from "@songtradr-one/shared-common";
import { NotificationItem } from "../../../shared/components/notification-item/NotificationItem";
import { useNotificationsFeed } from "../../../shared/hooks/use-notifications-feed";
import {
  EmptyState,
  NotificationsPanelList_Query,
  NotificationsPanelList_Subscription,
  PAGE_SIZE,
  PanelList,
  Props,
  text,
} from "../notifications-panel-list/NotificationsPanelList.Parts";

export const NotificationsPanelList = ({ activeTab, onNavigate }: Props) => {
  const data = useNotificationsFeed(
    NotificationsPanelList_Query,
    NotificationsPanelList_Subscription,
    { limit: PAGE_SIZE, offset: 0 },
  );
  const notifications = data.notifications.user?.items ?? [];

  const visible =
    activeTab === "unread"
      ? notifications.filter(
          (item) => item.status === NotificationStatus.Unread,
        )
      : notifications;

  return visible.length ? (
    <PanelList>
      {visible.map((item) => (
        <NotificationItem
          key={item.id}
          notification={item}
          onNavigate={onNavigate}
        />
      ))}
    </PanelList>
  ) : (
    <EmptyState variant="normal">
      {activeTab === "unread" ? text.emptyUnread : text.empty}
    </EmptyState>
  );
};
